import React from 'react';
import {
  RegisterOptions,
  useFormContext,
} from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';
import { NAME_REGEX } from 'src/utilities/regexPatterns';

export interface BaseFirstNameInputProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
  label?: string;
}

export const BaseFirstNameInput: React.FC<BaseFirstNameInputProps> = ({
  name,
  id,
  rules = {},
  label = 'First Name *',
}) => {
  const { errors, control } = useFormContext();

  return (
    <CookbookInputWrapper
      maxLength={60}
      name={name}
      id={id}
      control={control}
      error={errors[name]}
      aria-label={label}
      inputSize="medium"
      blockWidth
      label={label}
      placeholder="First"
      rules={{
        pattern: {
          value: NAME_REGEX,
          message:
            "First name must contain only alphanumeric characters and , . ' _ - ( ) | / @ & #",
        },
        ...rules,
      }}
    />
  );
};
